import React from "react";
import PropTypes from "kf-proptypes/widgets";

import {
  SingleLine,
  SINGLELINE_TYPE,
  SINGLELINE_SIZES,
  FieldLabel,
  LABEL_SIZE
} from "@widgets/inputs/index.jsx";
import {
  KfIcon,
  ICON_SIZE,
  KF_ICONS,
  ICON_STROKE
} from "@widgets/common/components/primitives/kf_icon/index.jsx";

import styles from "./styles.css";

SingleLineExpression.propTypes = {
  expressionIcon: PropTypes.node.isRequired,
  onExpressionClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  expressionText: PropTypes.string.isRequired,
  required: PropTypes.bool
};

SingleLineExpression.defaultProps = {
  expressionIcon: (
    <KfIcon
      icon={KF_ICONS.FORMULA}
      size={ICON_SIZE.SIZE_16}
      stroke={ICON_STROKE.THIN}
      color={"--kf-color-white"}
    />
  ),
  onExpressionClick: () => {}
};

export function SingleLineExpression({
  expressionText,
  onExpressionClick,
  expressionIcon,
  label,
  required,
  ...singleLineProps
}) {
  return (
    <div className={styles.expressionInputContainer}>
      <FieldLabel label={label} required={required} size={LABEL_SIZE.MEDIUM} />

      {!expressionIcon ? (
        <SingleLine {...singleLineProps} size={SINGLELINE_SIZES.MEDIUM} />
      ) : (
        <div
          className={`${styles.inputContainer} ${
            expressionIcon ? styles.withExpressionIcon : ""
          }`}
        >
          <div className={`${styles.iconWrapper}`}>
            <div className={styles.icon}>{expressionIcon}</div>
          </div>

          <SingleLine
            {...singleLineProps}
            styleType={SINGLELINE_TYPE.MINIMAL}
            size={SINGLELINE_SIZES.MEDIUM}
          />
        </div>
      )}

      {expressionText ? (
        <div className={styles.expressionContainer}>
          <span
            onClick={onExpressionClick}
            className={`micro ${styles.expressionText}`}
          >
            <KfIcon
              icon={KF_ICONS.EXTERNAL_LINK}
              size={ICON_SIZE.SIZE_8}
              stroke={ICON_STROKE.THIN}
              color={"--kf-color-primary-500"}
            />
            {expressionText}
          </span>
        </div>
      ) : null}
    </div>
  );
}
